export const META_DATA = {
    PORTION_LENGTH: 50,
    RELOAD_SCROLL_DIFF: 100,
    HIDE_SEARCH_LENGTH: 10,
};
